import React, { useContext } from "react";
import NotificationContext from "../../contexts/notification";
import Banner from "./Banner";
import styles from "./notification.module.css";

const Notification = () => {
  const [notificationState, dispatcher] = useContext(NotificationContext);

  return (
    <div className={styles.notification}>
      {notificationState.notifications.map((notification) => (
        <Banner
          notification={notification}
          dispatcher={dispatcher}
          key={notification.id}
        />
      ))}
    </div>
  );
};

export default Notification;
